import { z } from 'zod';

export const addFormPortfolioSchema = z.object({
  type: z.enum(['PORTFOLIO', 'ESTIMATION']),

  location: z.number(),

  propertyType: z.number(),
  propertyView: z.string(),
  finishType: z.string(),
  area: z.number().min(1),
  rooms: z.number().min(1),
  baths: z.number().min(1),

  purchasePrice: z.number(),
  purchaseDate: z.string(),

  expectedValuationPrice: z.number().optional(),
});

export const addFormEstimationSchema = z.object({
  type: z.enum(['PORTFOLIO', 'ESTIMATION']),
  location: z.number(),
  propertyType: z.number(),
});

export type FormType = z.infer<typeof addFormPortfolioSchema>;
